import { connect } from 'react-redux';

import { StateType } from 'types';
import {
  selectPartner,
  selectServiceProvider,
  selectUser,
  selectUserStartup,
  selectUserType,
  selectUserAngelInvestor,
  selectUserTechnicalLicense,
} from 'redux/selectors/auth';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
  partner: selectPartner(state),
  serviceProvider: selectServiceProvider(state),
  startup: selectUserStartup(state),
  angelInvestor: selectUserAngelInvestor(state),
  technicalLicense: selectUserTechnicalLicense(state),
  user: selectUser(state),
});

export default connect(mapStateToProps);
